document.addEventListener('DOMContentLoaded', function () {
  // Get the mobile footer and sticky buy bar elements
  var mobileFooter = document.querySelector('.mobile-footer');
  var stickyBuyBar = document.querySelector('.sticky-buy-bar');

  // Function to hide elements
  function hideElements() {
    if (mobileFooter) mobileFooter.classList.add('hidden');
    if (stickyBuyBar) stickyBuyBar.classList.add('hidden');
  }

  // Function to show elements
  function showElements() {
    if (mobileFooter) mobileFooter.classList.remove('hidden');
    if (stickyBuyBar) stickyBuyBar.classList.remove('hidden');
  }

  // Function to check if the burger menu is open
  function checkBurgerMenu() {
    var burgerMenu = document.querySelector('.mobile-header-block .menu-drawer-container');
    return burgerMenu && burgerMenu.classList.contains('menu-opening');
  }

  // Function to check if the filters window is open (similar approach to the burger menu)
  function checkFiltersWindow() {
    var filtersWindow = document.querySelector('.disclosure-has-popup.medium-hide.large-up-hide');
    return filtersWindow && filtersWindow.classList.contains('menu-opening');
  }

  // Function to check if the AJAX cart drawer is open
  function checkCartDrawer() {
    var cartDrawer = document.querySelector('.drawer.active');
    return cartDrawer !== null;
  }

  // Function to update visibility based on menu, drawer, and filters window states
  function updateVisibility() {
    if (checkBurgerMenu() || checkCartDrawer() || checkFiltersWindow()) {
      hideElements();
    } else {
      showElements();
    }
  }

  // Event listener for burger menu, cart drawer, and filters window open/close
  document.body.addEventListener('click', function (event) {
    updateVisibility();
  });

  // MutationObserver to handle dynamic changes to class attributes
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        updateVisibility();
      }
    });
  });

  // Observe changes in class attributes on the menu-drawer-container element
  var menuDrawer = document.querySelector('.mobile-header-block .menu-drawer-container');
  if (menuDrawer) {
    observer.observe(menuDrawer, { attributes: true });
  }

  // Observe changes in class attributes on the cart drawer element
  var cartDrawer = document.querySelector('.drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true });
  }

  // Observe changes in class attributes on the filters window element
  var filtersWindow = document.querySelector('.disclosure-has-popup.medium-hide.large-up-hide');
  if (filtersWindow) {
    observer.observe(filtersWindow, { attributes: true });
  }

  // Initial check
  updateVisibility();
});



